import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="border-t border-zinc-800 bg-zinc-950">
      <div className="mx-auto max-w-6xl px-6 py-12">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <Link to="/" className="text-xl font-semibold tracking-tight text-white">
              Ghost<span className="text-emerald-400">Inbox</span>
            </Link>
            <p className="mt-3 text-sm leading-relaxed text-zinc-400">
              Privacy-focused temporary inbox platform at @ghostinbox.xyz. Built for software
              testing, QA workflows, and spam protection with secure, account-linked access.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            <div>
              <h3 className="text-xs font-semibold uppercase tracking-wider text-zinc-500">
                Product
              </h3>
              <ul className="mt-4 space-y-2 text-sm">
                <li>
                  <Link to="/about" className="text-zinc-300 transition hover:text-white">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/how-it-works" className="text-zinc-300 transition hover:text-white">
                    How it works
                  </Link>
                </li>
                <li>
                  <Link to="/pricing" className="text-zinc-300 transition hover:text-white">
                    Pricing
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-zinc-300 transition hover:text-white">
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-xs font-semibold uppercase tracking-wider text-zinc-500">
                Account
              </h3>
              <ul className="mt-4 space-y-2 text-sm">
                <li>
                  <Link to="/login" className="text-zinc-300 transition hover:text-white">
                    Login
                  </Link>
                </li>
                <li>
                  <Link to="/signup" className="text-zinc-300 transition hover:text-white">
                    Sign Up
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-xs font-semibold uppercase tracking-wider text-zinc-500">
                Legal
              </h3>
              <ul className="mt-4 space-y-2 text-sm">
                <li>
                  <Link to="/privacy" className="text-zinc-300 transition hover:text-white">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="text-zinc-300 transition hover:text-white">
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link to="/acceptable-use" className="text-zinc-300 transition hover:text-white">
                    Acceptable Use Policy
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-zinc-800 pt-6 text-center text-sm text-zinc-500">
          © {new Date().getFullYear()} ghostinbox.xyz. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
